import { SubmitHandler, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { FieldError } from 'react-hook-form'
import { t } from 'i18next'
import { useNavigate } from 'react-router-dom'

import style from './ChangePassword.module.css'
import PasswordInput from '../../../common/components/Auth/PasswordInput'
import ProfileBase from '../../../components/Profile/ProfileBase'
import { changePassword } from '../../../common/utils/cognito'
import { EmailPassFormInputs } from '../../../types/EmailPassFormInputs'

const schema = yup.object().shape({
  oldPassword: yup.string().required(),
  newPassword: yup
    .string()
    .required()
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
      'Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character',
    ),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref('newPassword'), undefined], 'Passwords must match'),
})

const ChangePassword = () => {
  const navigate = useNavigate()
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<any>({ resolver: yupResolver(schema) })

  const onSubmit: SubmitHandler<EmailPassFormInputs> = async (data) => {
    if (!data.oldPassword || !data.newPassword) return
    try {
      await changePassword(data.oldPassword, data.newPassword)
      console.log('Password successfully changed')
    } catch (error) {
      console.log('Failed to change password:', error)
    }
  }

  return (
    <ProfileBase
      backButtonAction={() => navigate('/profile')}
      title={t('profile.changePassword')}
      buttonTitle={t('profile.changePassword')}
      onButtonClick={handleSubmit(onSubmit)}
    >
      <form className={style.formContainer}>
        <div>
          <PasswordInput
            register={register}
            errors={errors}
            name="oldPassword"
            label={t('profile.oldPassword')}
          />
          {errors.oldPassword && (
            <p className={style.error}>
              {(errors.oldPassword as FieldError)?.message}
            </p>
          )}

          <PasswordInput
            register={register}
            errors={errors}
            name="newPassword"
            label={t('profile.newPassword')}
          />

          {errors.newPassword && (
            <p className={style.error}>
              {(errors.newPassword as FieldError)?.message}
            </p>
          )}
          <PasswordInput
            register={register}
            errors={errors}
            name="confirmPassword"
            label={t('profile.confirmPassword')}
          />
          {errors.confirmPassword && (
            <p className={style.error}>
              {(errors.confirmPassword as FieldError)?.message}
            </p>
          )}
        </div>
        <div>
          <p>
            <em>{t('signup.passwordComplexity')}</em>
          </p>
        </div>
      </form>
    </ProfileBase>
  )
}

export default ChangePassword
